import { expensifyLinkSuccess } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

const linkExpensifySuccess = () => addMessage(expensifyLinkSuccess);
export default linkExpensifySuccess;
